/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { ContractResource } from './';
import {
    ContractResourceFromJSON,
    ContractResourceFromJSONTyped,
    ContractResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { ProjectAmountsResource } from './';
import {
    ProjectAmountsResourceFromJSON,
    ProjectAmountsResourceFromJSONTyped,
    ProjectAmountsResourceToJSON,
} from './';
import type { ProjectAppraisalResource } from './';
import {
    ProjectAppraisalResourceFromJSON,
    ProjectAppraisalResourceFromJSONTyped,
    ProjectAppraisalResourceToJSON,
} from './';
import type { ProjectDetailsResource } from './';
import {
    ProjectDetailsResourceFromJSON,
    ProjectDetailsResourceFromJSONTyped,
    ProjectDetailsResourceToJSON,
} from './';
import type { ProjectOptionsResource } from './';
import {
    ProjectOptionsResourceFromJSON,
    ProjectOptionsResourceFromJSONTyped,
    ProjectOptionsResourceToJSON,
} from './';
import type { ProjectStatus } from './';
import {
    ProjectStatusFromJSON,
    ProjectStatusFromJSONTyped,
    ProjectStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInformationResource
 */
export interface ProjectInformationResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    conversationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    correlationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResource
     */
    billingReference?: string;
    /**
     * 
     * @type {ContractResource}
     * @memberof ProjectInformationResource
     */
    contract: ContractResource;
    /**
     * 
     * @type {Client}
     * @memberof ProjectInformationResource
     */
    client: Client;
    /**
     * 
     * @type {Freelancer}
     * @memberof ProjectInformationResource
     */
    freelancer: Freelancer;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof ProjectInformationResource
     */
    projectStatus: ProjectStatus;
    /**
     * Whether the expense tracker is active or not
     * @type {boolean}
     * @memberof ProjectInformationResource
     */
    expenseTrackerEnable: boolean;
    /**
     * 
     * @type {ProjectAppraisalResource}
     * @memberof ProjectInformationResource
     */
    appraisalForClient?: ProjectAppraisalResource;
    /**
     * 
     * @type {ProjectAmountsResource}
     * @memberof ProjectInformationResource
     */
    amounts: ProjectAmountsResource;
    /**
     * 
     * @type {ProjectDetailsResource}
     * @memberof ProjectInformationResource
     */
    details: ProjectDetailsResource;
    /**
     * 
     * @type {ProjectOptionsResource}
     * @memberof ProjectInformationResource
     */
    options: ProjectOptionsResource;
}

/**
 * Check if a given object implements the ProjectInformationResource interface.
 */
export function instanceOfProjectInformationResource(value: object): value is ProjectInformationResource {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('projectStatus' in value) || value['projectStatus'] === undefined) return false;
    if (!('expenseTrackerEnable' in value) || value['expenseTrackerEnable'] === undefined) return false;
    if (!('amounts' in value) || value['amounts'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function ProjectInformationResourceFromJSON(json: any): ProjectInformationResource {
    return ProjectInformationResourceFromJSONTyped(json, false);
}

export function ProjectInformationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'conversationId': json['conversationId'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'billingReference': json['billingReference'] == null ? undefined : json['billingReference'],
        'contract': ContractResourceFromJSON(json['contract']),
        'client': ClientFromJSON(json['client']),
        'freelancer': FreelancerFromJSON(json['freelancer']),
        'projectStatus': ProjectStatusFromJSON(json['projectStatus']),
        'expenseTrackerEnable': json['expenseTrackerEnable'],
        'appraisalForClient': json['appraisalForClient'] == null ? undefined : ProjectAppraisalResourceFromJSON(json['appraisalForClient']),
        'amounts': ProjectAmountsResourceFromJSON(json['amounts']),
        'details': ProjectDetailsResourceFromJSON(json['details']),
        'options': ProjectOptionsResourceFromJSON(json['options']),
    };
}

export function ProjectInformationResourceToJSON(value?: ProjectInformationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectId': value['projectId'],
        'conversationId': value['conversationId'],
        'correlationId': value['correlationId'],
        'billingReference': value['billingReference'],
        'contract': ContractResourceToJSON(value['contract']),
        'client': ClientToJSON(value['client']),
        'freelancer': FreelancerToJSON(value['freelancer']),
        'projectStatus': ProjectStatusToJSON(value['projectStatus']),
        'expenseTrackerEnable': value['expenseTrackerEnable'],
        'appraisalForClient': ProjectAppraisalResourceToJSON(value['appraisalForClient']),
        'amounts': ProjectAmountsResourceToJSON(value['amounts']),
        'details': ProjectDetailsResourceToJSON(value['details']),
        'options': ProjectOptionsResourceToJSON(value['options']),
    };
}

